import { SVGProps } from 'react';
const SvgArrowDownLeftSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 8-8 8M14 16H8v-6"
    />
  </svg>
);
export default SvgArrowDownLeftSm;
